/*
 * @Description: user Mutations
 */
import { MutationTree } from 'vuex'
import {
  ComputerState,
  ConfigState,
  NavListState,
  FooterConfigState,
  FooterDefault,
  FooterTemplate1,
  FooterTemplate2,
  pageConfig,
  PageHeader,
  PageClassifyNav,
  PageCourseGroup,
  PageRichText,
} from '@/constant/computerType'
import { ComputerMutationTypes } from './mutation-types'

export type Mutations<S = ComputerState> = {
  [ComputerMutationTypes.SET_NAV_CONFIG](state: S, data: ConfigState): void
  [ComputerMutationTypes.ADD_NAV_CONFIG_LIST](state: S, data: NavListState): void
  [ComputerMutationTypes.DEL_NAV_CONFIG_LIST](state: S, data: NavListState): void
  [ComputerMutationTypes.MODIFY_NAV_CONFIG_LIST](state: S, data: NavListState): void
  [ComputerMutationTypes.SET_FOOTER_CONFIG](state: S, data: FooterConfigState): void
  [ComputerMutationTypes.PC_MODIFY_PAGE_CONFIG](state: S, data: Array<pageConfig | PageHeader | PageClassifyNav | PageCourseGroup | PageRichText>): void
  [ComputerMutationTypes.SUBMIT_AND_PREVIEW_PAGE](state: S, pageHeaderConfig:{ preview:false, submit:false}): void
}

export const mutations: MutationTree<ComputerState> & Mutations = {
  //导航
  [ComputerMutationTypes.SET_NAV_CONFIG](state: ComputerState, data: ConfigState) {
    state.navConfig = data
  },
  [ComputerMutationTypes.ADD_NAV_CONFIG_LIST](state: ComputerState, data: NavListState) {
    state.navConfig.datas.push(data)
  },
  [ComputerMutationTypes.DEL_NAV_CONFIG_LIST](state: ComputerState, data: any) {
    state.navConfig.datas = data
  },
  [ComputerMutationTypes.MODIFY_NAV_CONFIG_LIST](state: ComputerState, data: any) {
    state.navConfig.datas = data
  },

  //页脚
  [ComputerMutationTypes.SET_FOOTER_CONFIG](state: ComputerState, data: FooterConfigState) {
    state.footerConfig = data
  },


  //微门户配置
  [ComputerMutationTypes.PC_MODIFY_PAGE_CONFIG](state: ComputerState, data: Array<pageConfig | PageHeader | PageClassifyNav | PageCourseGroup | PageRichText>) {
    state.pageDesignConfig = data
  },

  //预览保存事件
  [ComputerMutationTypes.SUBMIT_AND_PREVIEW_PAGE](state: ComputerState, data: { preview:false, submit:false}) {
    state.pageHeaderConfig = data
  },

}
